export const peppers = [
  {
    name: "Smokin' Ed's Carolina Reaper",
    imageURL: "https://i.imgur.com/SsudIiU.jpg",
    scoville: "1,641,300",
    description: "This pepper holds the record for worlds hottest pepper. It is a beautiful bright red with a rough surface and a long stinger. But don't let its good looks fool you! This pepper got its name for a reason. If you are stupid enough to eat this pepper whole you may wish to enter the doors of death willingly!",
  },
  {
    name: "Trinidad Moruga Scorpion",
    imageURL: "https://i.imgur.com/w7HvO2t.jpg",
    scoville: "1,600,000+",
    description: "The Trinidad Moruga scorpion has a tender fruit-like flavor, which makes it a sweet-hot combination. native to the village of Moruga, Trinidad and Tobago. It is one of the spiciest chilies in the world. In 2012 it was identified as the hottest chili at that time.",
  },
  {
    name: "Seven-Pot Habanero",
    imageURL: "https://i.imgur.com/DWswZgS.jpg",
    scoville: "1,200,000+",
    description: "The wrinkly, pocked skin tells the tale of a wolf in sheep’s clothing – there’s a heat here near the Trinidad Moruga Scorpion, making the 7 Pot pepper one of the hottest chilies in the world. Yet behind this heat is a delicious habanero-like fruity, nutty flavor that follows its Caribbean roots",
  },
  {
    name: "Ghost Pepper",
    imageURL: "https://i.imgur.com/BNFlNSl.jpg",
    scoville: "1,000,000+",
    description: "Also known as the Bhut Jolokia, which means Bhutanese chili in Assamese. In 2007, Guinness World Records certified that the ghost pepper was the world's hottest chili pepper. It is used in both fresh and dried forms to heat up curries, pickles and chutneys. It is popularly used in combination with pork or dried or fermented fish.",
  },
  {
    name: "Orange Habanero",
    imageURL: "https://i.imgur.com/1fqyQfp.jpg",
    scoville: "350,000",
    description: "In 1999, the habanero was listed by Guinness World Records as the world's hottest chili, but it has since been displaced by other peppers. Breeders constantly crossbreed subspecies to attempt to create cultivars that will break the record on the Scoville scale. One example is the Carolina Reaper, a cross between a Bhut jolokia pepper with a particularly pungent red habanero. The habanero's heat, flavor and floral aroma make it a popular ingredient in hot sauces and other spicy foods.",
  },
  {
    name: "Scotch Bonnet",
    imageURL: "https://i.imgur.com/DcAkCiX.jpg",
    scoville: "325,000",
    description: "Scotch bonnet, also known as bonney peppers, or Caribbean red peppers,are a variety of chili pepper named for their resemblance to a tam o' shanter hat. These peppers are used to flavor many different dishes and cuisines worldwide and are often used in hot sauces and condiments. The Scotch bonnet has a sweeter flavor and stouter shape, and gives jerk dishes (pork/chicken) and other Caribbean dishes their unique flavor.",
  },
  {
    name: "Red Thai Chilli Pepper",
    imageURL: "https://i.imgur.com/75J8liR.jpg",
    scoville: "150,000",
    description: "The bird's eye chili, bird eye chili, bird's chili, or Thai chili is a chili pepper variety from the species Capsicum annuum, commonly found in Ethiopia and across Southeast Asia. These chilis are highly valued for their fruity taste and extreme spiciness. Both the green and ripe red chilis are extensively used in many Thai dishes, such as in Thai curries and in Thai salads, and are even eaten raw on the side.",
  },
  {
    name: "Cayenne Pepper",
    imageURL: "https://i.imgur.com/dRaosis.jpg",
    scoville: "50,000",
    description: "The cayenne pepper is a type of Capsicum annuum. It is usually a moderately hot chili pepper. It is used in its fresh form, or as dried powder on seafood, all types of egg dishes (devilled eggs, omelettes, soufflés), meats and stews, casseroles, cheese dishes, hot sauces, and curries.",
  },
  {
    name: "Jalapeño",
    imageURL: "https://i.imgur.com/dCzMfnq.jpg",
    scoville: "8,000",
    description: "The jalapeño is a medium-sized chili pepper pod type cultivar of the species Capsicum annuum. Commonly picked and consumed while still green, it is occasionally allowed to fully ripen and turn red, orange, or yellow. The jalapeño is a Mexican chile but was adopted by Texas as the state pepper in 1995. In Mexico jalapeños are used in many dishes, such as: salsa takis, pico de gallo, or grilled jalapeños. Jalapeños were included as food on the Space Shuttle as early as 1982.",
  },
]